import {inject} from '@angular/core';
import {Router, CanActivateFn} from '@angular/router';
import {AppService} from '@services/app.service';

export const isAdminGuard: CanActivateFn = (route, state) => {
    const authService = inject(AppService);
    const router = inject(Router);

    const isAuthenticated = authService.isLoggedIn();
    const isAdmin = authService.isAdminUser();

    if (!isAuthenticated || !isAdmin) {
        router.navigate(['/']);
        return false;
    }
    return true;
};
